import { css } from 'styled-components';
import { media } from './';

export const ShowForMediumUp = css`
  display: none;

  @media ${media.small} {
    display: block;
  }
`;

export const HideForSmallOnly = css`
  @media ${media.medium} {
    display: none;
  }

  @media ${media.small} {
    display: none;
  }
`;

export const ShowForSmallOnly = css`
  display: none;

  @media ${media.mobile} {
    display: inline-block;
  }
`;

export default {
  ShowForMediumUp,
  HideForSmallOnly,
  ShowForSmallOnly,
};
